module.exports = __webpack_public_path__ + "static/media/Dyal Singh.a3610af1.mp3";